class DateTime {
  // 构造方法
  constructor() {
    // 列举Week
    this.weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    // 获取当前时间
    this.Date = new Date();
    // 获取当前年
    this.year = this.Date.getFullYear();
    // 获取当前月
    this.month = this.Date.getMonth() + 1;
    // 获取当前日
    this.date = this.Date.getDate();
    // 获取当前星期几
    this.day = this.Date.getDay();
    // 获取小时
    this.hour = this.Date.getHours();
    // 获取分钟
    this.minute = this.Date.getMinutes();
    // 获取秒
    this.second = this.Date.getSeconds();
    //获取毫秒数
    this.millise = this.Date.getTime();
    // 自动补零
    this.month = (this.month < 10) ? '0' + this.month : this.month = this.month;
    this.date = (this.date < 10) ? '0' + this.date : this.date = this.date;
    this.minute = (this.minute < 10) ? '0' + this.minute : this.minute = this.minute;
    this.second = (this.second < 10) ? '0' + this.second : this.second = this.second;
  };

  /**
   * 获取新时间
   * @returns {string}
   */
  Now() {
    
    return this.getDate() + ' ' + this.getTime();
  }
  /**
   * 取当前日期
   * @returns {string}
   */
  getDate() {
    return this.year + '-' + this.month + '-' + this.date + '';
  };
  /**
   * 获取当前时间
   * @returns {string}
   */
  getTime() {
    return this.hour + ':' + this.minute + ':' + this.second;
  };
  /**
   * 获取当前星期几
   *@returns {string}
   */
  getWeek() {
    return this.weekday[this.day]
  };

  /**
   * 
   * @param {int} 加入前毫秒 
   * @param {int} 加入后毫秒
   */
  getSecond(beforeMillisecond, afterMillisecond) {
    return (afterMillisecond - beforeMillisecond) / 1000;
  };

  /**
   * 获取昨天
   */
  getYesterday() {
     
    var time = (new Date).getTime() - 24 * 60 * 60 * 1000;
    var yesterday = new Date(time);
     
    var month = yesterday.getMonth();
     
    var day = yesterday.getDate();
    yesterday = yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1 > 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 9 ? (yesterday.getDate()) : "0" + (yesterday.getDate()));
    return yesterday
  }

  convertSSAndMin(ss) {
    let min = Math.floor(ss / 60);
    let second = (ss % 60 / 100).toFixed(2).slice(-2)
    let returns = '';
    if (min > 0) {
      if (min < 10) {
        returns = `0${min}`
      } else {
        returns = min
      }
      returns += "分钟"
    }
    returns += second
    return returns + 's'
  }
  /**
   * 秒转时间
   * @param {秒} msd 
   */
  secondToDate(msd) {
    if (msd == null || msd == undefined || msd == 0) {
      return '--'
    }
    var time = msd
    if (null != time && '' != time) {
      if (time > 60 && time < 60 * 60) {
        time =
          parseInt(time / 60.0) +
          '分' +
          parseInt(
            (parseFloat(time / 60.0) - parseInt(time / 60.0)) *
            60
          ) +
          '秒'
      } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
        time =
          parseInt(time / 3600.0) +
          '时' +
          parseInt(
            (parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) *
            60
          ) +
          '分' +
          parseInt(
            (parseFloat(
                (parseFloat(time / 3600.0) -
                  parseInt(time / 3600.0)) *
                60
              ) -
              parseInt(
                (parseFloat(time / 3600.0) -
                  parseInt(time / 3600.0)) *
                60
              )) *
            60
          ) +
          '秒'
      } else if (time >= 60 * 60 * 24) {
        time =
          parseInt(time / 3600.0 / 24) +
          '天' +
          parseInt(
            (parseFloat(time / 3600.0 / 24) -
              parseInt(time / 3600.0 / 24)) *
            24
          ) +
          '小时' +
          parseInt(
            (parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) *
            60
          ) +
          '分' +
          parseInt(
            (parseFloat(
                (parseFloat(time / 3600.0) -
                  parseInt(time / 3600.0)) *
                60
              ) -
              parseInt(
                (parseFloat(time / 3600.0) -
                  parseInt(time / 3600.0)) *
                60
              )) *
            60
          ) +
          '秒'
      } else {
        time = parseInt(time) + '秒'
      }
    }

    return time
  }



  /**
   * 获取时间戳
   */
  getTimestamp(time) { //把时间日期转成时间戳
    return (new Date(time)).getTime() / 1000
  }

}
export {
  DateTime
}



// WEBPACK FOOTER //
// ./src/utils/common.js